import template from './record-groups-modal.pug';

export const RecordGroupsModalComponent = {
  template,
  bindings: {
    resolve: '<',
    modalInstance: '<',
  },
  controller: class RecordGroupsModalComponent {
    constructor(RecordGroup,$async, $log) {
      'ngInject';
      this.RecordGroup = RecordGroup;
      this.$log = $log;
      this.assignedGroups = [];
      this.groups = [];
      this.getGroups = $async(this.getGroups.bind(this));
      this.tabs = ['select', 'create'];
      this.activeTab = this.tabs[0];
    }

    $onInit() {
      if (this.resolve) {
        this.recordId = this.resolve.recordId;
        this.module = this.resolve.module;
        this.assignedGroups = this.resolve.assignedGroups;
        this.getGroups();
      }
      this.maxHeight = window.innerHeight - 300;
      this.maxHeight = this.maxHeight < 200 ? 200 : this.maxHeight;
      this.maxHeight = this.maxHeight > 500 ? 500 : this.maxHeight;

      this.newGroup = {
        name: '',
        emoji: this.RecordGroup.getRandomEmoji(),
        module: this.module,
      };
    }

    toggle(group) {
      group.selected = !group.selected;
    }

    count() {
      return this.groups.filter(group => group.selected).length;
    }

    updateEmoji({emoji}) {
      this.newGroup.emoji = emoji;
    }

    async create() {
      try {
        const group = await this.RecordGroup.create(this.newGroup);
        this.groups.forEach(group => group.selected = false);
        group.selected = true;
        this.groups.push(group);
        this.done();
      } catch (e) {
        this.$log.error(e);
      }
    }

    async done() {
      try {
        const selectedGroups = this.groups.filter(group => group.selected);
        const seletectedGroupIds = selectedGroups.map(group => group.id);
        const groups = await this.RecordGroup.assign(this.recordId, this.module, seletectedGroupIds);
        this.modalInstance.close(groups);
      } catch (e) {
        this.$log.error(e);
      }
    }

    async getGroups() {
      try {
        const resp = await this.RecordGroup.getList(this.module, {});
        if (resp && resp.length) {
          this.groups = resp.filter(group => !this.assignedGroups.find(assignedGroup => assignedGroup.id === group.id));
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    close() {
      this.modalInstance.close();
    }
  }
};
